import React from 'react';
import CodeSnippet from '../../../../components/CodeSnippet';
import {
  ContentBlock,
  CostLabel,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../EnvironmentSetup.styles';

interface IEnvironmentOwnershipProps {
  projectCodeName: string;
  projectBillCode: string;
  clientName: string;
  projectManagingDirector: string;
  projectManager: string;
}
export const EnvironmentOwnershipSection = ({
  projectCodeName,
  projectBillCode,
  clientName,
  projectManagingDirector,
  projectManager,
}: IEnvironmentOwnershipProps) => {
  return (
    <SectionWrapper animationIndex={2}>
      <Title>Environment ownership</Title>
      <ContentBlock>
        <Description>
          General information about environment owners, billing code and client
          name
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Codename</CostLabel>
            <CodeSnippet>{projectCodeName || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Bill / Matter code</CostLabel>
            <CodeSnippet>{projectBillCode || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Client name</CostLabel>
            <CodeSnippet>{clientName || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
      <ContentBlock>
        <Description />
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Managing Director</CostLabel>
            <CodeSnippet>{projectManagingDirector || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Information Owner</CostLabel>
            <CodeSnippet>{projectManagingDirector || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Project Manager</CostLabel>
            <CodeSnippet>{projectManager || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
